export const normalizeAppointmentTime = (value = '') => {
  const raw = String(value || '').trim().replace(/^(?:at\s+)/i, '');
  const twelveHour = raw.match(/^(\d{1,2})(?:[:.]([0-5]\d))?\s*([ap])\.?m\.?$/i);
  if (twelveHour) {
    let hour = Number(twelveHour[1]);
    if (hour < 1 || hour > 12) return '';
    hour %= 12;
    if (twelveHour[3].toLowerCase() === 'p') hour += 12;
    return `${String(hour).padStart(2, '0')}:${twelveHour[2] || '00'}`;
  }
  return /^([01]\d|2[0-3]):[0-5]\d$/.test(raw) ? raw : '';
};
